import { CLEAR_SNIPPETS, UPDATE_SNIPPETS } from "../reducers/actiontypes";

const initialState = (function(state=[]) {
	return state;
})(window.commentstate.snippets);

export default function(state=initialState, action) {
	switch (action.type) {
		case CLEAR_SNIPPETS:
			return [];
		case UPDATE_SNIPPETS:
			return action.snippets;
		default:
			return state;
	}
}